import React, {useEffect, useState} from "react";
import {createConnection} from "../services/fetch";
import {postEvent} from '@telegram-apps/sdk';

import {Card, CardBody, CardTitle} from "reactstrap";

import {useSearchParams} from "react-router-dom";
import {useDom} from "../context/dom";

const {GoogleGenerativeAI} = require("@google/generative-ai");

const Intro = (p) => {
  const [text, setText] = useState(null);
  const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GEMINI);
  const model = genAI.getGenerativeModel({model: "gemini-2.0-flash"});

  const trans = async (tt) => {
    const len = p.len ? 'translated into '+p.len +' language' : '';
    const prompt = "return 2 sentences long lead "+len+" in HTML format with highlighted important words with 'strong' tag for this article: " + tt.replace(/<[^>]*>/g, '');
    const resp = await model.generateContent(prompt).then(
      o => {
        const rt=o.response.text().replace('html','').replace(/`/g,'');
        console.log(rt);
        setText(rt);
      }
      ).catch(er=>{console.log(err)})



  }
  useEffect(() => {
    trans(p.t);

  }, []);
  return (
<>
    {
      text &&
    (
      <div dangerouslySetInnerHTML={{__html:text}}></div>
    )
}
</>
)
}

export default function Farm(props) {


  /* */


  const dom = useDom();
  const [searchParams, setSearchParams] = useSearchParams();


  const [page, setPage] = useState([]);
  let num;

  let tms = 1;
  let nn = 0;
  const links = [];
  const pgss = [];
  const swp = (e) => {

    console.log(e)

  }
  const getAuthor = (a, author) => {

    createConnection().get_T0('users/' + author, '').then(t => {

      Object.keys(t.avatar_urls).map((o, i) => {
        t.avatar = t.avatar_urls[o]
      })
      a.author = t;

    });


  }
  const share = (a) => {

    window.Telegram.WebApp.shareToStory(a.source_url, {text: a.excerpt.rendered.replace(/<\/?[^>]+(>|$)/g, '') + '...'});
  }
  const getPost = async (n) => {
    createConnection().get_T('posts', '_fields=link,id,title,modified,excerpt,author,featured_media,content&per_page=20&page=' + n).then(a => {
      nn = n;
      let ids = []
      a.res.then(p => {

        p.map((u, i) => {
          ids.push(u.id);
//console.log(u);
        })


        createConnection().get_T('media', '_fields=id,title,caption,link,source_url&parent=' + ids.join(',')).then(y => {
          y.res.then(x => {
            x.map((u, i) => {
              //
              if ((u.title.rendered + u.caption.rendered).match(/otolitsyn/)) {

                const h = (p.find(b => b.featured_media == u.id));
                if (h) {
                  u.link = h.link;
                  u.modified = h.modified;
                  u.excerpt = h.excerpt;
                  u.date = new Date(h.modified);
                  u.atitle = h.title;
                  u.ran = Math.floor(Math.random() * 8);
                  if (pgss.length < 6) {
                    const rr = h.content.rendered.replace(/<[^>]*>/g, '');
                  u.ret=rr;
                  u.len=pgss.length==2 ? 'Russian' : pgss.length==3  ? 'Kazakh' : pgss.length==4  ? 'Kirgiz' : pgss.length==5 ? 'Uzbeki' : '';
                  }
                  pgss.push(u);
                  getAuthor(u, h.author);

                  setPage(page => {
                    return [...page, u]
                  });
                  num++;

                } else {

                  //u.link=u.link.split('/').splice(0,4).join('/');
                }


              }


            })


          })

        });


      })
      if (n == 1) {

        document.addEventListener("scroll", (event) => {
          const pgs = document.getElementsByClassName('pg');


          const a = pgs[pgs.length - 1];
          //  console.log(a.offsetTop , window.scrollY+window.innerHeight,pgss.length,num*tms);
          // const b=a.getBoundingClientRect();
          if (a.offsetTop < window.scrollY + window.innerHeight && pgss.length == num * tms) {
            num = 0;
            tms++;
            getPost(nn + 1);
            //
            const test = pgss.find(r => r.id == a.id)
            console.log('test', test);
          }


        })

      }


      if (num < 20) {
        // console.log(num,pgss.length);
        getPost(n + 1);
      }

    }).catch(s => console.log(s))
  }
  const getIm = (n) => {

    createConnection().get_T('media', 'search=potolitsyn&_fields=id,title,caption,link,source_url&per_page=20&page=' + n).then(a => {

      a.res.then(p => {
          p.map((u, i) => {
            // num++;
            const se = u.link.split('/');
            se.pop();
            se.pop();
            // console.log();
            u.link = se.join('/');
            const test = pgss.find(r => r.link == u.link);
            test == undefined && pgss.push(u);
            setPage(page => {
              const test = page.find(r => r.link == u.link)
              return test == undefined ? [...page, u] : page;
            });
            /**/

          })
        }
      )

      //  num+20 < a.total && getIm(n+1);
    })

  }
  const openL = (a) => {


    postEvent('web_app_open_link', {url: a.link, try_instant_view: true});
    // window.Telegram.WebApp.web_app_open_link()

  }

  useEffect(() => {


    //window.Telegram.WebApp.initDataUnsafe.user &&  console.log(window.Telegram.WebApp.initDataUnsafe.user);
    num = 0;
    if (window.Telegram.WebApp.initDataUnsafe.user) {
      window.Telegram.WebApp.setHeaderColor('#000000');
      window.Telegram.WebApp.setBackgroundColor('#000000');
      window.Telegram.WebApp.setBottomBarColor('#000000');

    }

    //postEvent('web_app_set_header_color', { color_key: '#000000' });

    //if(page !== 'f')  console.log('farm');
    const n = 1;
    getPost(n);
    //   getIm(n);

  }, []);
  return (
    <div className="bg-black pt-4" style={{maxWidth: '480px'}}>
      <div>
        {(page && page.length > 0) && page.map((a, i) =>
          (
            <div key={i} className='pg  mb-4' id={a.id}>
              <Card className="bg-gray-800 rounded overflow-hidden shadow-2xl text-white">
                <CardBody onClick={() => openL(a)}>
                  <div className="sq text-sm" style={{backgroundImage: 'url(' + a.source_url + ')'}}>
                    <img src={require('../static/TCA.png')}/>
                    <div className={'tit t' + a.ran}>
                      {a.atitle && a.atitle.rendered.split(' ').map((m, i) =>
                        (

                          <span key={i} dangerouslySetInnerHTML={{__html: m}}/>

                        )
                      )


                      }

                    </div>

                  </div>


                  <CardTitle tag="h5" className="p-4">
                    <div className="grid grid-cols-8 gap-4">
                      <div className="col-span-8">
                        {a.ret ? (

                         <Intro t={a.ret} len={a.len}/>

                        ) : (

                          <div className="exc"
                               dangerouslySetInnerHTML={{__html: a.excerpt ? a.excerpt.rendered : ''}}></div>

                        )

                        }


                      </div>
                      <div>
                        {(a.author && a.author.name) &&

                          (
                            <div>
                              <img width="48" height={48} className="rounded-full" src={a.author.avatar}/>


                            </div>
                          )

                        }

                      </div>
                      <div className="col-span-3 text-xs">
                        {(a.author && a.author.name) &&
                          (
                            <div className="text-gray-400">{a.author.name}<br/>
                              <div>    {a.date && a.date.toDateString()}</div>
                            </div>
                          )}
                      </div>

                      <div className="col-span-3 text-xs">
                        <svg onClick={() => share(a)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                             strokeWidth={2.5}
                             stroke="#eeeeff"
                             className="size-6">
                          <path strokeLinecap="round" strokeLinejoin="round"
                                d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"/>
                        </svg>

                      </div>
                    </div>


                  </CardTitle>


                </CardBody>
              </Card>
            </div>


          )
        )}
      </div>
    </div>
  );
}
